import React, { FC } from 'react'
import apiGateway from '../../../services/apiGateway'
import Countdown from '@bt-react/components/Countdown'
import Button from '@bt-react/components/Button'
import { ParticipantInformationInterface } from '../../../dataStore/reducers/docs/syncUi/types'
import componentStyles from '../ControlCentreMain.module.scss'
import { format, parseISO } from 'date-fns'
import { toggleAudio, toggleVideo } from '../../../dataStore/actions/tracks/trackActions'
import { useDispatch } from 'react-redux'

interface TalksControlProps {
  roomname: string | undefined
  isLiveReady: boolean
  isLive: boolean
  date: string
  title: string
  webcastURL: string
  participantInfo: ParticipantInformationInterface[]
  muted: string[]
  videoDisplay: string[]
  presentersInRoom: string[]
}

const TalksControl: FC<TalksControlProps> = ({
    roomname = '',
    isLiveReady,
    isLive, date = '', title = '',
    webcastURL, participantInfo,
    muted, videoDisplay, presentersInRoom }) => {

  const handleClick = () => isLiveReady ? apiGateway.goLive(roomname) : console.log('This talk is not ready to go live')
  const handleEndClick = () => apiGateway.endLive(roomname)
  const talksAuditLink = `${apiGateway.getBTBasePath()}/talks-audit?id=${roomname}`
  const dispatch = useDispatch<any>()
  const handleMuteToggleClick = (id: string) => dispatch(toggleAudio(id))
  const handleVideoToggleClick = (id: string) => dispatch(toggleVideo(id))

  const participants = () => participantInfo.map(participant => {
    if (!presentersInRoom.includes(participant.id)) return false
    return <div key={participant.id} className={componentStyles['participants']}>
      <p><strong>Name: </strong> {participant.firstName + ' ' + participant.lastName}</p>
      <p><strong>id: </strong> {participant.id}</p>
      <p><strong>Job Title: </strong> {participant.jobTitle}</p>
      <p><strong>Displaying video: </strong> {!videoDisplay.includes(participant.id) ? 'True' : 'False'}</p>
      <p className={componentStyles['last']}><strong>Currently muted: </strong> {muted.includes(participant.id) ? 'True' : 'False'}</p>
      <Button onClick={() => handleMuteToggleClick(participant.id)}>{muted.includes(participant.id) ? 'Unmute' : 'Mute '} participant</Button>
      <Button onClick={() => handleVideoToggleClick(participant.id)}>{videoDisplay.includes(participant.id) ? 'Show participant video' : 'Hide participant video'}</Button>
    </div>
  })

  return <>
    <h3>Talk Control</h3>
    <br />
    <p><strong>Talk Title:</strong> {title}</p>
    <p><strong>Start date: </strong> {date !== '' && format(new Date(parseISO(date)), 'dd/MM/yyyy HH:mm')} <br />
      {
        isLive ? <div>This talk is currently live</div> :
        <Countdown
          date={date}
          color='black'
          countdownText='Live in'
        />
      }
    </p>

    <p>Webcast URL: <a href={webcastURL} target='_blank' rel="noreferrer">{webcastURL}</a></p>
    <div><strong>Talks Audit Link:</strong> <a href={talksAuditLink} target='_blank' rel="noreferrer">Talks Audit</a></div>
    <br />
    {isLive && <Button onClick={handleEndClick}>End Talk</Button>}
    {isLiveReady && <p>This talks is ready to go live, click to start: <Button disabled={!isLiveReady} onClick={handleClick}>Start Talk</Button></p>}

    <p><strong>Number of Presenters: </strong> {presentersInRoom.length}</p>
    <strong>Presenters</strong>
    {presentersInRoom.length < 1 ? <p>There are currently no presenters in the room</p> : participants()}
  </>
}

export default TalksControl